import React, { useState } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/LoginClientes.css'

function LoginClientes() {
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const RegistroCliente = async (event) => {
        event.preventDefault();
        try {
            console.log('datos a enviar:', { usuario, password });

            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/cliente/login`, {
                username: usuario,
                password,

            });
            if (response.data) {
                console.log(response.data);
                
              await descargarDatosCliente(response.data.user_email)
            }

        } catch (error) {
            alert("nombre de usuario o contraseña incorrecto vuelva a intentarlo")
            console.error('Error al autenticar al usuario:', error);
        }

    }
    const descargarDatosCliente = async (email) => {
    try {     
        const pedidosResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/pedidowp/correo/${email}`);
        const pedidosData = pedidosResponse.data;
        navigate(`/cliente/${pedidosResponse.data[0].cliente_id}`, { state: { pedidosData } });
         
    } catch (error) {
        alert("No se encuentran cursos pendientes de documentación con este correo. Revise los datos o pongase en contacto con nosotros")
        console.error('Error al descargar los datos del cliente:', error);
    }
}
   

    return (
        <div className="contenedorBody">
            <div className="contenedorLogo">
                <img src="LogoEZOS.png" width="15%" height="auto" alt="Ezos" />
            </div>
            <div className="mensaje"><h2>Bienvenido a la página de entrega de documentación de alumnos</h2></div>
            <div className="ContenedorLogin">
                <h4>Para identificarse utilice las mismas claves que uso para reservar el curso</h4>
                <form onSubmit={RegistroCliente}>
                    <label className="titulo">
                        Usuario:
                        <input type="text" value={usuario} onChange={(e) => setUsuario(e.target.value)} />
                    </label>
                    <br />
                    <label className="titulo">
                        Contraseña:
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </label>
                    <br />
                    <button className="botonLogin" type="submit">
                        Enviar
                    </button>
                </form>
            </div>
            <div className="footer">
                <div className="contacto">
                    <p>
                        <b>CONTACTO</b> <br />
                        EZOS S.L. <br />
                        CIF: B30870745 <br />
                        https://ezos.es <br />
                        email: info@ezos.es</p>
                </div>
                <div className="sedes">
                    <p>
                        <b>SEDE CARTAGENA</b> <br />
                        C/ Palas 10 Bajo <br />
                        30202 Cartagena. España. <br />
                        T (34) 868068296
                    </p>
                </div>
                <div className="sedes">
                    <p>
                        <b>SEDE VALLADOLID</b> <br />
                        C/ Manuel Azaña 15 Bajo <br />
                        47014 Valladolid. España <br />
                        T (34) 983 454337
                    </p>
                </div>
                <div className="sedes">
                    <p>
                        <b>SEDE SOCIAL</b> <br />
                        C/ Sobrado 1 Bajo B <br />
                        28050 Madrid. España.
                    </p>
                </div>
                <div className="redes">
                    <a href="https://www.facebook.com/ezos.es"> <img className="logoRedes" src="/redes/facebook.png" alt="facebook" title="Siguenos en Facebook" /></a>
                    <a href="https://www.instagram.com/ezossl/"><img className="logoRedes" src="/redes/instagram.png" alt="instagram" title="Siguenos en Instagram" /></a>
                    <a href="https://www.linkedin.com/company/ezossl"><img className="logoRedes" src="/redes/linkedin.png" alt="linkedin" title="Siguenos en Linkedin" /></a>
                    <a href="https://x.com/ezos_es"><img className="logoRedes" src="/redes/x.png" alt="x" title="Siguenos en X" /></a>
                    <a href="https://www.youtube.com/channel/UCakXh8HAGVD6l4tXPrQkTGw"><img src="/redes/youtube.png" alt="youtube" title="Siguenos en YouTube" /></a>
                </div>

            </div>
        </div>
    )

}



export default LoginClientes;